<template>
    <div class="single-file-alert alert">
        <div class="single-file-box alert_box">
            <h3>신고가 정상 접수되었습니다.<br/>빠른 시일 내에 수정하도록 하겠습니다.</h3>
            <div class="single-file-check">
                <p @click="$emit('closeModal')">확인</p>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: 'ConfirmMusicReport'
});
</script>

<style scoped>
  .modal {
    z-index: 1057;
  }
  p {
    text-align: center;
  }
</style>
